

import { form16DataInfoType } from '@/types/Information/Form16';
import { partiesDataJsonDataType } from '@/types/Information/json';
import { Component, Vue } from 'vue-property-decorator';

import { namespace } from "vuex-class";
import "@/store/modules/information";
const informationState = namespace("Information");

import "@/store/modules/forms/form16";
const form16State = namespace("Form16");

@Component
export default class Form16StyleOfProceeding extends Vue {

    @informationState.State
    public partiesJson: partiesDataJsonDataType;   

    @informationState.State
    public fileNumber: string;

    @form16State.State
    public form16Info: form16DataInfoType;

    @form16State.Action
    public UpdateForm16Info!: (newForm16Info: form16DataInfoType) => void  
    
    @form16State.State
    public currentOfferToSettleCostsId: string;

    @form16State.Action
    public UpdateCurrentOfferToSettleCostsId!: (newCurrentOfferToSettleCostsId: string) => void
    
    dataReady = false;
    applicantNames: string[] = [];
    respondentNames: string[] = [];
    partyNames: string[] = [];
    otherPartyNames: string[] = [];

    state = {
        firstAppellant: null,
        firstRespondent: null,
        offeringParties:null,
        amount: null,
        receivingParties: null,        
        authorizedName:null
    }
   
    updated=0;  
    invalidOfferingParties = false;

    mounted() {
        this.dataReady = false;
        this.extractInfo();              
    }

    public extractInfo(){

        this.invalidOfferingParties = false;

        if(this.currentOfferToSettleCostsId){
            this.getForm16Data();
           
        } else {   
            
            const form16Data = {} as form16DataInfoType;

            form16Data.appellants = this.partiesJson.appellants
            form16Data.respondents = this.partiesJson.respondents;
            form16Data.formSevenNumber = this.fileNumber;
            
            form16Data.version = this.$store.state.Application.version; 
           
            this.UpdateForm16Info(form16Data);                       
            this.saveForm(true);
        }            

    }

    public extractPartiesData(){

        this.applicantNames = [];
        this.respondentNames = [];
        this.partyNames = [];

        for (const respondent of this.form16Info.respondents){
            this.respondentNames.push(respondent.name); 
            this.partyNames.push(respondent.name) 
        }

        for (const applicant of this.form16Info.appellants){
            this.applicantNames.push(applicant.name);
            this.partyNames.push(applicant.name);  
        }
        this.updateOtherParties()
        this.dataReady = true;

    }

    public getForm16Data() {        
       
        this.$http.get('/form16/forms/'+this.currentOfferToSettleCostsId)
        .then((response) => {
            if(response?.data?.data){            
                            
                const form16Data = response.data.data                
                this.UpdateForm16Info(form16Data) 
                this.extractPartiesData();
                this.clearStates();                
            }
                
        },(err) => {
            console.log(err)        
        });      
    }

     public clearStates(){
        this.state = {
            firstAppellant: null,
            firstRespondent: null,
            offeringParties:null,
            amount: null,
            receivingParties: null,        
            authorizedName:null
        }
        this.dataReady = true; 
    }

    public recheckStates(){
        for(const field of Object.keys(this.state)){
            if(this.state[field]==false){
                this.checkStates()
                return 
            }
        }
    }

    public checkStates(){   
        
        this.state.firstAppellant = !this.form16Info.firstAppellant? false : null;
        this.state.firstRespondent = !this.form16Info.firstRespondent? false : null; 
        this.state.offeringParties = this.form16Info.offeringParties?.length>0? null :false;
        this.state.amount = !this.form16Info.amount? false : null;
        this.state.receivingParties = this.form16Info.receivingParties?.length>0? null :false;
        this.state.authorizedName = !this.form16Info.authorizedName? false : null;       
        
        for(const field of Object.keys(this.state)){
            if(this.state[field]==false){
                Vue.filter('findInvalidFields')()
                return false
            }            
        }
        return true            
    }    

    public saveForm(draft: boolean) { 
        
        let method = 'post';
        let url = '/form16/forms';

        if (this.currentOfferToSettleCostsId){
            method = 'put';
            url = '/form16/forms/'+this.currentOfferToSettleCostsId;               

            if (!draft && !this.checkStates()){               
                return                
            } 
            
            const options = {
                method: method,
                url: url,
                data: {
                    data:this.form16Info,
                    type:'Form16',
                    description:'Offer To Settle Costs'
                }
            }
            this.saveInfo(options, draft);

        } else {           

            const options = {
                method: method,
                url: url,
                data: {
                    data:this.form16Info,
                    type:'Form16',
                    description:'Offer To Settle Costs'
                }
            }
            this.saveInfo(options, draft);
        }        
       
    }

    public saveInfo(options, draft){

        this.$http(options)
            .then(response => {
                if(response.data){
                    if(options.method == "post"){
                        this.UpdateCurrentOfferToSettleCostsId(response.data.file_id);
                        this.extractPartiesData();                        
                    }

                    this.clearStates();                    
                    if(!draft) this.navigateToPreviewPage();                           
                }
            }, err => {
                const errMsg = err.response.data.error;
                
            })
    }
    
    public updateOtherParties(){

        const otherParties = [];

        if (this.partyNames.length == this.form16Info.offeringParties?.length){

            this.invalidOfferingParties = true;

        } else {

            this.invalidOfferingParties = false;

            for (const partyName of this.partyNames){
                const index = this.form16Info.offeringParties?.indexOf(partyName)
                if (index == -1){
                    otherParties.push(partyName);
                }
            }
            this.otherPartyNames = otherParties;
            this.updated ++;
        }        
    }

    public navigateToPreviewPage() {        
        this.$router.push({name: "preview-form16"}) 
    }

}
